module.exports = __webpack_public_path__ + "img/SO.f89e77ad.svg";